import { useState, useEffect } from 'react';
import { ReceiptPb } from './protobufs/receipt_payload';
import { decode } from 'base45';
import { Alert, Box, Button, Stack } from '@mui/material';
import ReceiptLayout from './components/ReceiptLayout';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { generateReceiptPdf } from './logic/GenerateReceiptPdf';

export default function ReceiptView() {
  const [receiptData, setReceiptData] = useState<ReceiptPb | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const payloadBase45 = queryParams.get('r');

    if (!payloadBase45) {
      setError("Der Beleg konnte nicht gelesen werden.");
      return;
    }

    try {
      const payloadBytes = decode(payloadBase45);
      const receiptPb = ReceiptPb.fromBinary(Uint8Array.from(payloadBytes))

      setReceiptData(receiptPb);
    } catch (err) {
      setError("Der Beleg konnte nicht gelesen werden.");
      console.error(err);
    }
  }, [window.location.search]);

  const handleDownload = async () => {
    if (!receiptData) {
      return;
    }

    try {
      generateReceiptPdf(receiptData);
    } catch (error) {
      setError("Die PDF Datei konnte nicht erstellt werden");
      console.error('Error generating PDF:', error);
    }
  };

  return <>
    <Stack alignItems="center">
      {
        error &&
        <Alert color='error' sx={{ m: 2 }} icon={false}>{error}</Alert>
      }
      {
        receiptData && <>
          <Button variant='outlined' sx={{ m: 2 }} onClick={handleDownload}>
            <FileDownloadIcon sx={{ mr: 1 }} /> PDF Speichern
          </Button>
          <Box sx={{ mb: 10 }}>
            <ReceiptLayout receipt={receiptData}></ReceiptLayout>
          </Box>
        </>
      }
    </Stack>
  </>;
};